import * as React from 'react'
import { observer } from 'mobx-react'
import { QuestionDTO } from 'jobs/dtos/questions'
import { getQuestionComponentRegistryEntry } from 'jobs/questions/component-registry'
import { QuestionViewModelFor } from 'jobs/questions/type-registry'

interface Props<T extends QuestionDTO> {
  vm: QuestionViewModelFor<T>
}

export default observer(function ResponseValue<T extends QuestionDTO>({
  vm,
}: Props<T>) {
  const entry = getQuestionComponentRegistryEntry(vm.type)
  const ValueComponent = entry ? entry.ValueComponent : undefined
  return ValueComponent ? <ValueComponent vm={vm as any} /> : <>N/A</>
})
